import { createApp } from "vue";
import App from "./App.vue";
import store from "./store/index";
import router from "./routes/index";
import CanvasJSChart from "@canvasjs/vue-charts";
import FloatingVue from "floating-vue";
import { createPinia } from "pinia";
import i18n from "@/i18n/index.js";

const pinia = createPinia();

createApp(App)
  .use(store)
  .use(router)
  .use(CanvasJSChart)
  .use(FloatingVue)
  .use(pinia)
  .use(i18n)
  .mount("#app");